import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthGrantModel } from '@digilize/shared/definitions/src';

/** The OAuth side of pauly-mcp (PAUL-3659): the apps a person connected, and the way to disconnect one. */
@Injectable({ providedIn: 'root' })
export class OAuthApiService {
  readonly GRANTS_URL = '/api/v1.0/oauth/grants';

  constructor(private http: HttpClient) {}

  /** The caller's own connections; an admin may ask for another person's with `userId`. */
  getGrants(userId?: string) {
    return this.http.get<OAuthGrantModel[]>(this.GRANTS_URL, { params: userId ? { user: userId } : {} });
  }

  /** Every token the app holds stops working on its next call; the app has to ask the person to sign in again. */
  revokeGrant(id: string) {
    return this.http.delete<void>(`${this.GRANTS_URL}/${id}`);
  }
}
